import decodeFilters from './decodeFilters'

const { initialTags, initialProperties, initialSort, initialPrice } = decodeFilters()

const hasInicialTags = initialTags && Object.keys(initialTags).length !== 0 && initialTags.constructor === Object
const hasInicialProperties = initialProperties && Object.keys(initialProperties).length !== 0 && initialProperties.constructor === Object
const hasInicialSort = initialSort
const hasInicialPrice = initialPrice.length > 0

const hasFilterApplied = hasInicialTags || hasInicialProperties || hasInicialSort || hasInicialPrice

export default hasFilterApplied
